import React from "react"
import { graphql } from "gatsby"
import { Table, Container } from "react-bootstrap"
import "bootstrap/dist/css/bootstrap.min.css"

export const query = graphql`
  {
    allAirtable(
      filter: { table: { eq: "Items" } }
      sort: { fields: data___Name }
    ) {
      nodes {
        recordId
        data {
          Name
          Role
          Company {
            data {
              Name
              Logo {
                url
              }
            }
          }
        }
      }
    }
  }
`

export default ({ data }) => (
  <Container>
    <h1>Air Table Data</h1>
    <Table striped bordered hover>
      <thead>
        <tr>
          <th>Name</th>
          <th>Role</th>
          <th>Company</th>
          <th>Logo</th>
        </tr>
      </thead>
      <tbody>
        {data.allAirtable.nodes.map(node => (
          <tr>
            <td key={node.recordId}>{node.data.Name}</td>
            <td key={node.recordId}>{node.data.Role}</td>
            <td key={node.recordId}>{node.data.Company[0].data.Name}</td>
            <td key={node.recordId}>
              <img
                style={{ width: "50px", height: "25px" }}
                src={node.data.Company[0].data.Logo[0].url}
                alt={node.data.Company[0].data.Name}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  </Container>
)
